export const accountSetup = {
  payments: {
    planUnavailableTitle: "Not available on your plan",
    planUnavailableMessage:
      "Guest payments via Stripe are available only on Standard plans and above. Upgrade your plan to enable this feature and start collecting payments directly, with no intermediaries.",
  },
  modalConnection: {
    header: "Connect a PMS",
    loaderMessage: "Saving, please wait.",
    selectPmsLabel: "Select a PMS system",
    selectPmsPlaceholder: "Select a PMS",
    apiKeyLabel: "{pms} API Key",
    apiKeyPlaceholder: "Enter your API Key",
    cancel: "Cancel",
    save: "Save connection",
    fieldRequired: "Required field",
    selectPmsError: "Select a PMS",
    apiKeyError: "Please enter the API Key",
    savedTitle: "Connection saved",
    savedMessage: "The connection was saved successfully",
    saveFailMessage: "The connection could not be saved",
    errorTitle: "Error",
    serverError: "Error connecting to the server",
  },
  subscription: {
    title: "My subscription",
    subtitle: "View and manage your plan, payment method and billing.",
    statusActive: "Active",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Cancelled · active until",
    validUntil: "Active until:",
    statusPaymentPending: "Payment pending",
    statusTrial: "Trial period",
    statusNone: "No active subscription",
    intervalYearly: "Annual plan",
    intervalMonthly: "Monthly plan",
    perMonthShort: "/mo",
    nextRenewal: "Next renewal:",
    servicesIncluded: "Included services",
    units: "unit | units",
    perUnitSuffix: "/unit",
    serviceFallback: "Service",
    manageOpening: "Opening…",
    manageButton: "Manage subscription and invoices",
    emptyText:
      "You don't have an active plan yet. Choose one to start receiving check-ins and payments.",
    buyPlan: "Buy a plan",
    types: {
      apartment: "Apartment",
      hotel: "Hotel",
      room: "Room",
      camping: "Camping",
      villa: "Villa",
      chatbot: "AI Reception",
    },
  },
  purchased: {
    title: "Available in your subscription",
    subtitle: "Contracted allowance and current usage",
    accommodations: "Accommodations",
    empty: "You haven't created any accommodations yet.",
    createProperty: "Create property",
    adjust: "Adjust",
    loadError: "The information could not be loaded.",
    labels: {
      apartment: "Apartment(s)",
      hotel: "Hotel (Rooms)",
      hotelPack: "Hotel (Rooms) · #{id}",
      villa: "Villas",
      camping: "Campsites",
      campingPack: "Campsites · #{id}",
      chatbot: "Chatbot licenses",
    },
    units: {
      unid: "units",
      room: "rooms",
      spots: "spots",
      licenses: "licenses",
    },
    types: {
      hotel: "Hotel",
      camping: "Camping",
      villa: "Villa",
      apartment: "Apartment",
    },
    badge: {
      rooms: "{n} rooms",
      spots: "{n} spots",
      unit: "1 unit",
    },
  },
  notifications: {
    title: "Notifications",
    description: "Turn messaging automations and alerts on or off.",
    loading: "Loading settings...",
    alwaysActive: "Always on",
    active: "On",
    inactive: "Off",
    hint:
      "Note: some automations are shown as informational because they're already part of the system's standard flow.",
    loadError: "The settings could not be loaded.",
    saveError: "The change could not be saved. Retrying...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Booking confirmation (WhatsApp)",
        description:
          "Automatically sends the confirmation template when a booking is confirmed.",
      },
      email_checkin_sent: {
        title: "Email notifications when the check-in is sent",
        description:
          "Sends an automatic email when the check-in process is completed or sent.",
      },
      whatsapp_checkin_link_auto: {
        title: "Send automatic WhatsApp for online check-in",
        description:
          "Automatically sends the online check-in link via WhatsApp when applicable.",
      },
      checkin_link_send_policy: {
        title: "Check-in link sending policy for direct bookings",
        description:
          "Set whether the link is always sent or only when the booking is paid or partially paid.",
        options: {
          always: {
            label: "Always send",
            description:
              "Sends the check-in link regardless of payment status.",
          },
          paid_or_partially_paid: {
            label: "Only paid or partially paid",
            description:
              "Sends the link only if the booking is fully or partially paid. Applies to direct bookings only.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Colombia",
    statusVerified: "Connected",
    statusPending: "Not verified",
    publicKeyLabel: "Public Key",
    privateKeyLabel: "Private Key",
    keepPrivateLabel: "Keep the saved private key (hidden for security)",
    privatePlaceholderSaved: "•••••••••••• (saved)",
    btnDisconnect: "Disconnect",
    btnVerify: "Verify account",
    btnSave: "Save credentials",
    merchantHeader: "Merchant detected",
    missingPublicKey: "Public Key missing",
    missingPrivateKey: "Private Key missing",
    savedOk: "Credentials saved successfully",
    saveError: "Error saving the credentials",
    verifiedOk: "Account verified",
    notVerified: "Account not verified",
    verifyError: "Error verifying the account",
    disconnectConfirm: "Are you sure you want to disconnect Wompi from this business?",
    disconnectedOk: "Disconnected successfully",
    disconnectError: "Error disconnecting",
  },
  pricelabs: {
    subtitle: "Dynamic price optimization",
    statusConnected: "Connected",
    statusDisconnected: "Not connected",
    loading: "Loading settings...",
    emailLabel: "PriceLabs email",
    emailPlaceholder: "your-email@pricelabs.com",
    importantTitle: "Important:",
    bullet1: "Make sure your properties are fully configured",
    bullet2: "Choose which listings go to PriceLabs",
    bullet3:
      "Prices will update according to PriceLabs and can't be edited manually from Wacheckin",
    btnConnect: "Connect and sync",
    btnConnecting: "Connecting...",
    btnSync: "Sync",
    btnSyncing: "Syncing...",
    btnDisconnect: "Disconnect",
    btnDisconnecting: "Disconnecting...",
    emailRequired: "Please enter your PriceLabs email",
    emailRequiredTitle: "Email required",
    connectHeader: "Connect with PriceLabs?",
    connectMessage:
      "All your active properties and rooms will be linked. Rates and availability will sync. Any property/room created afterwards will be sent automatically.",
    connectAccept: "Yes, connect",
    cancel: "Cancel",
    linkError: "Error linking units",
    emailNotFoundConnect:
      "PriceLabs reported that the email doesn't exist. Check your email and try again.",
    emailInvalidTitle: "Invalid PriceLabs email",
    syncSuccess: "Your properties are now connected with PriceLabs.",
    syncSuccessTitle: "Sync complete!",
    syncFail: "The sync could not be completed",
    errorTitle: "Error",
    emailNotFoundManual:
      "PriceLabs indicated that the email doesn't exist. Correct the email and sync again.",
    manualSuccess: "The process completed successfully.",
    manualSuccessTitle: "Manual sync",
    manualFail: "Could not sync with PriceLabs",
    rejected: "PriceLabs rejected {count} listing(s). {detail}",
    rejectedTitle: "Could not sync",
    nothingSent: "No listing was sent. Check that the ones you picked have a price and a currency.",
    relinked: "{count} listing(s) were still tied to another PriceLabs account: they were sent with a new id, so they show up there as new listings.",
    relinkedTitle: "New id",
    syncedAt: "Synced · {when}",
    notSyncedYet: "Connected, not sent yet",
    noneSelected: "You haven't picked any property. Select the ones you want in PriceLabs and sync again.",
    disconnectHeader: "Disconnect PriceLabs?",
    disconnectMessage: "All your properties will be unlinked from PriceLabs.",
    disconnectAccept: "Yes, disconnect",
    disconnectedOk: "Your account has been disconnected from PriceLabs",
    disconnectedTitle: "Disconnected",
    disconnectFail: "Could not disconnect from PriceLabs",
    noErrorsReported: "No errors reported.",
    listingPrefix: "Listing {id}: ",
    unknownError: "Unknown error",
    listTitle: "Which listings go to PriceLabs",
    listHint: "Choose which ones PriceLabs should manage. The ones you leave off keep their prices and you edit them yourself.",
    listCount: "{n} of {total} selected",
    listSearch: "Search a property or a room…",
    listRooms: "{n} rooms",
    listApartment: "Apartment",
    listEmpty: "You don't have any properties yet.",
    listNoMatch: "No property with that name.",
    listNeedsCurrency: "Missing currency",
    listNeedsRate: "Missing a rate plan",
    btnConnectN: "Connect and sync | Connect and sync {n} | Connect and sync {n}",
    unitConnected: "{name} now goes to PriceLabs",
    unitDisconnected: "{name} no longer goes to PriceLabs",
    unitFail: "Couldn't change it. Please try again.",
    listLocked: "Connect your PriceLabs account and you'll be able to choose which listings it manages here.",
    listAll: "All",
    listNone: "None",
    btnSyncN: "Sync | Sync 1 listing | Sync {n} listings",
    connectedOk: "Account connected. Now choose which listings go to PriceLabs.",
    connectedTitle: "Done",
  },
};
